import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { Observable, Subscriber } from 'rxjs';

import { RunStatus } from 'src/app/runs/run-status.enum';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RunsHubService {
  private connection: HubConnection;

  constructor() {
    this.connection = new HubConnectionBuilder()
      .withUrl(`${environment.host}/hubs/runs`)
      .withAutomaticReconnect()
      .build();

    this.connection.onclose((error) => {
      console.log('SignalR Connection Closed: ', error);
    });
  }

  startConnection(): Observable<void> {
    return new Observable((observer) => {
      this.connection
        .start()
        .then(() => {
          observer.next();
        })
        .catch((error) => {
          console.error('Error connecting to SignalR hub:', error);
        });
    });
  }

  joinGroup() {
    this.connection.invoke('JoinGroup', environment.signalRGroup)
      .catch(err => console.error(err));
  }

  runStatusChanged() {
    return new Observable((observer: Subscriber<{ runId: string, runStatus: RunStatus }>) => {
      this.connection.on('RunStatusChanged', (runId: string, runStatus: RunStatus) => {
        observer.next({ runId, runStatus });
      });
    });
  }
}
